import { Component, ElementRef, HostBinding, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { isInsideControl } from '@shared/helpers';

@Component({
    selector: 'app-status-chip',
    templateUrl: './status-chip.component.html',
    styleUrls: ['./status-chip.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StatusChipComponent implements OnInit {
  static readonly componentName = 'StatusChipComponent';
  
  @Input() text: string;
  @Input() icon: string;
  @Input() tooltip: string;

  @Input() set removeMargin(val: boolean) {
    this.margin = val;
  }

  @HostBinding('class.margin') margin: boolean;

  // inside a control (a button, link, panel header, option, label...) the chip can't be a toggletip button of its own:
  // it then keeps its plain icon, and its message is hidden text read with the control
  public insideControl = false;

  constructor(private el: ElementRef<HTMLElement>) {}

  // the chip's own template hasn't been checked yet, so it renders the right way the first time
  ngOnInit(): void {
    this.insideControl = isInsideControl(this.el.nativeElement);
  }
}
